<sc-flex fitHeight vertical stretchContent>

  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.title"></sc-dictionary-label>
  </sc-dialog-title>

  <app-transport-info-panel [carrier]="stepperModel.workingData.carrier"
    [identifier]="stepperModel.workingData.identifier" [driver]="stepperModel.workingData.driver"
  [scope]="stepperModel.workingData.transportScope"></app-transport-info-panel>

  <sc-flex-fitting-content vertical>
    <sc-padding fitHeight>
      @if (isActionSelection()) {
        <app-select-action></app-select-action>
      }
      @if (isDetachTruckAndTrailer()) {
        <app-detach-truck-and-trailer>
        </app-detach-truck-and-trailer>
      }
      @if (isDetachTruck()) {
        <app-detach-truck></app-detach-truck>
      }
      @if (isDetachTrailer()) {
        <app-detach-trailer></app-detach-trailer>
      }
      @if (isDetachTrailerFromSemiTrailerTruck()) {
        <app-detach-trailer-semi-trailer-truck
        ></app-detach-trailer-semi-trailer-truck>
      }
      @if (isAttachTruck()) {
        <app-attach-truck></app-attach-truck>
      }
      @if (isAttachTrailer()) {
        <app-attach-trailer></app-attach-trailer>
      }
      @if (isSelectTrailerSwapTarget()) {
        <app-select-trailer-swap-target></app-select-trailer-swap-target>
      }
      @if (isTrailerSwapSourceDetails()) {
        <app-trailer-swap-source-details></app-trailer-swap-source-details>
      }
    </sc-padding>
  </sc-flex-fitting-content>

  <app-service-response [responseMessages]="responseMessages"></app-service-response>

  <sc-actionbar>
    @if (isPreviousStepVisible()) {
      <sc-back-button dictionaryKey="tmc-yard.common.action.previous" (click)="showPreviousStep()"></sc-back-button>
    }
    <sc-content-spacer grow></sc-content-spacer>
    <sc-cancel-button (click)="cancel()"></sc-cancel-button>
    <sc-content-spacer></sc-content-spacer>
    @if (showNextStepButtonVisible()) {
      <sc-forward-button dictionaryKey="tmc-yard.common.action.next" primary (click)="showNextStep()" class="confirm-button" [disabled]="!stepCompleted()"
      ></sc-forward-button>
    }
    @if (showFinishButtonVisible()) {
      <sc-button dictionaryKey="tmc-yard.common.action.finish" primary (click)="finish()" class="confirm-button"
      [disabled]="actionRunning || !stepCompleted()"></sc-button>
    }
  </sc-actionbar>

</sc-flex>
